export const SITE_COLORS = [
  {
    color: '#FF2882',
    name: 'Pink'
  },
  {
    color: '#FF6900',
    name: 'Orange'
  },
  {
    color: '#EBFF00',
    name: 'Yellow'
  },
  {
    color: '#00FF87',
    name: 'Green'
  },
  {
    color: '#05F0FF',
    name: 'Blue'
  },
  {
    color: '#963CFF',
    name: 'Lilac'
  },
  {
    color: '#37003C',
    name: 'Purple'
  },
  {
    color: '#A08C6E',
    name: 'Gold'
  },
  {
    color: '#5A505F',
    name: 'Grey'
  },
  {
    color: '#96968C',
    name: 'Light Grey'
  },
  {
    color: '#EBEBE6',
    name: 'Stone'
  }
]
